import React from "react";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/sagas/funnelChart/funnelChart";
import { useDispatch, useSelector } from "react-redux";

export const SubAverageFilter = () => {
  const dispatch = useDispatch();
  const { selectedSubAverageFilterOptions, average, subAverageFilterOptions } = useSelector(
    (state) => state.funnelChart
  );
  return (
    <MultiSelectDropdown
      filterType=""
      options={subAverageFilterOptions[average]}
      selectedFilters={selectedSubAverageFilterOptions}
      onSelectChange={(data) => dispatch(actionCreators.setSubAverageSelectedOptions(data))}
      selectAll={false}
      enableOnly
      numberDisplayed={0}
      includeSelectAll
      displayCheckedOnly
      haveOnSelectChange
    />
  );
};
